import styled from 'styled-components';

const NRICInput = styled.input`
    box-shadow: none;
    border-radius: 0;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: 0.063rem solid ${props => props.theme.color};

    flex-shrink: 1;
    min-width: 0;
    width: 2.5rem;
    height: 3.125rem;

    text-align: center;
    font-size: 2rem;

    margin: 0 0.225rem;

    &:focus {
        outline: none;
    }
    @media only screen and (max-width: 480px)
    {
        &.input_nric {
            padding:0;
            font-size: 1.4rem;
            flex-shrink: 0;
            line-height: normal;
            outline-offset: 0;
            vertical-align: top;
            padding-top: 4px;
        }
        &.input_otp {
            padding:0;
            font-size: 1.4rem;
            flex-shrink: 0;
            line-height: normal;
            outline-offset: 0;
            vertical-align: top;
            padding-top: 4px;
        }
    }

    @media only screen and  (min-width:760px){
        margin: 0 0.313rem;
    }
`;

export default NRICInput;